import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

export const selectLogsIsLoading = (store: StoreSchema) => store.logs.isLoading
export const selectProductLogs = (store: StoreSchema) => store.logs.productLogs

export const selectProductsLiveLogs = (store: StoreSchema) =>
    store.logs.productsLiveLogs

export const selectOneProductLiveLogs = (guid: string) =>
    createSelector(
        [selectProductsLiveLogs],
        (productsLiveLogs) => productsLiveLogs[guid]
    )
